import React, { ReactElement } from 'react'
import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '@mindfulchefuk/design-system'

const Jcb = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 26 16" {...props}>
    <rect width="26" height="16" rx="2" ry="2" fill="#2464b4" />
    <g fill="#fff">
      <path d="M16.44 9.09h1.1a.44.44 0 00.34-.44.44.44 0 00-.34-.43h-1.1v.89z" />
      <path d="M17.3 2.91a1.69 1.69 0 00-1.69 1.7v1.76h2.56c.54 0 .94.31.94.79a.79.79 0 01-.77.77V8c.55 0 1 .35 1 .82s-.47.85-1.08.85H15.6v3.45h2.49a1.69 1.69 0 001.69-1.7V2.91z" />
      <path d="M17.76 7.28a.4.4 0 00-.35-.4h-1v.82h.97a.39.39 0 00.38-.42z" />
    </g>
    <path
      d="M7.92 2.91a1.69 1.69 0 00-1.69 1.7v4.18a3.24 3.24 0 001.46.38.8.8 0 00.9-.83v-2h1.46v2c0 .76-.48 1.39-2.09 1.39a6.93 6.93 0 01-1.74-.23v3.57h2.49a1.69 1.69 0 001.69-1.69V2.91zM12.61 2.91a1.69 1.69 0 00-1.69 1.7v2.22a3.35 3.35 0 012.37-.55 7.55 7.55 0 011.34.21v.72a3.27 3.27 0 00-1.29-.38c-.91-.06-1.46.39-1.46 1.17s.55 1.24 1.46 1.17a3.45 3.45 0 001.29-.38v.72a7.36 7.36 0 01-1.34.21 3.35 3.35 0 01-2.37-.55v3.92h2.49a1.69 1.69 0 001.69-1.7V2.91z"
      fill="#fff"
    />
  </Svg>
)

export default Jcb
